import React, { Component } from 'react';
import { connect } from 'react-redux';
import Calendar from 'react-calendar';

import Modal from '../../containers/common/Modal';
import { FlyInTransition } from '../../components/transitions/transitions';
import { PrimaryButton } from '../common/Buttons';
import { ButtonText } from '../common/Text';

import calendarIcon from '../../images/consultations/calendar.svg';
import crossIcon from '../../images/common/cross.svg';
import arrowLeft from '../../images/reimbursement/arrow-left.svg';
import arrowRight from '../../images/reimbursement/arrow-right.svg';

export class CalendarModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: true,
      selectedDate: '',
      emergencyreimbursment: '',
      totalemergencyreimbursment: '',
      showEmergency: false,
    };
    // console.log(props);
  }

  componentDidMount() {}

  hideModal = () => {
    this.setState({ showModal: false });
    setTimeout(this.props.hideModal, 200);
  };

  handleOutsideClick = (e) => {
    // ignore clicks on the component itself
    if (
      (this.node && this.node.contains(e.target)) ||
      (this.node2 && this.node2.contains(e.target))
    ) {
      return;
    }
    this.hideModal();
  };

  onChange = (e) => {
    // console.log(e);
    this.setState({
      selectedDate: e,
    });
    this.props.selectedDate(e);
  };

  onProceed = () => {
    console.log('check here');
    this.setState({ showModal: false });
    this.props.onDateSelection(this.state.selectedDate);
  };

  render() {
    const { slots } = this.props;
    let minDate, maxDate;
    if (slots?.length > 0) {
      minDate = new Date(slots[0].date);
      maxDate = new Date(slots[slots?.length - 1].date);
    }
    return (
      <Modal>
        <div className="modalContainer" onClick={this.handleOutsideClick}>
          <FlyInTransition
            in={this.state.showModal}
            mountOnEnter
            unmountOnExit
            appear
          >
            <div
              className="bg-textbox absolute bottom-0px w-full rounded-t-12 overflow-auto"
              style={{ minHeight: '450px' }}
              ref={(node) => (this.node = node)}
            >
              <div className="p-20 border-b border-txtsecondary-shades7 border-solid flex flex-row items-center justify-between">
                <div className="flex flex-row items-center">
                  <img src={calendarIcon} alt="home" />
                  <span className="text-title-s ml-10px font-semibold text-txtlight">
                    Select Date to Schedule Follow-up
                  </span>
                </div>
                <img src={crossIcon} alt="cross" onClick={this.hideModal} />
              </div>
              <div className="p-20">
                <div className="flex flex-row justify-center">
                  {slots.length > 0 ? (
                    <Calendar
                      onChange={this.onChange}
                      value={this.state.selectedDate}
                      next2Label={false}
                      prev2Label={false}
                      className="reimbursent-calendar"
                      tileGroup={false}
                      calendarType="US"
                      minDate={minDate}
                      maxDate={maxDate}
                      nextLabel={
                        <img
                          src={arrowRight}
                          alt="arrow-right"
                          style={{
                            height: '24px',
                            width: '24px',
                          }}
                        />
                      }
                      prevLabel={
                        <img
                          src={arrowLeft}
                          alt="arrow-left"
                          style={{
                            height: '24px',
                            width: '24px',
                          }}
                        />
                      }
                      tileDisabled={({ date }) =>
                        !slots.some(
                          (slot) =>
                            date.getDate() === new Date(slot.date).getDate()
                        )
                      }
                    />
                  ) : (
                    <p className="text-body-l text-sub font-semibold">
                      There are no available dates to schedule an appointment.
                    </p>
                  )}
                </div>
                {this.state.selectedDate ? (
                  <div>
                    <div className="mt-40">
                      <PrimaryButton
                        onTap={() => {
                          this.onProceed();
                          // this.props.onDateSelection();
                        }}
                      >
                        <ButtonText>Submit</ButtonText>
                      </PrimaryButton>
                    </div>
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>
          </FlyInTransition>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
});

export default connect(mapStateToProps)(CalendarModal);
